import React from "react";
import { Typography, Box } from "@mui/material";
import { useDrag } from "react-dnd";

const WidgetCard = ({ widget }: { widget: any }) => {
  const [, dragRef] = useDrag(() => ({
    type: "WIDGET",
    item: {
      widget,
      fromFormId: "widget-panel",
      
    },
  }));

  return (
    <Box
      ref={dragRef}
      sx={{
        marginBottom: "8px",
        padding: "8px",
        width: "130px",
        backgroundColor: "#ffffff",
        border: "1px solid #ddd",
        borderRadius: "4px",
        display: "flex-column",
        alignItems: "center",
        justifyContent: "center",
        justifyItems: "center",
        gap: "8px",
        cursor: "grab",
      }}
    >
      <Typography sx={{ fontSize: "24px" }}>{widget.icon}</Typography>
      <Typography sx={{ fontSize: "16px" }}>{widget.name}</Typography>
    </Box>
  );
};

export default WidgetCard;
